module.exports = __webpack_public_path__ + "static/media/right.e230c71c.svg";